import { render } from "./chat_new.vue?vue&type=template&id=54e93eee"
import script from "./chat_new.js?vue&type=script&lang=js&external"
export * from "./chat_new.js?vue&type=script&lang=js&external"

import "./chat_new.vue?vue&type=style&index=0&id=54e93eee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__